// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-header {
    text-align: center;
    margin-bottom: 16px;
    margin-top: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Requerimento/View/DadosConfimacaoRequerimento.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB","sourcesContent":[".title-header {\n    text-align: center;\n    margin-bottom: 16px;\n    margin-top: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
